import React from "react";

const UploadButton = (props) => {
    const hiddenFileInput = React.useRef(null);

    const handleClick = (e) => {
        e.preventDefault();
        hiddenFileInput.current.click();
    };

    const handleChange = (e) => {
        e.preventDefault();
        const fileUploaded = e.target.files[0];
        props.handleFile(fileUploaded);
    };

    return(
        <React.Fragment>
            <div className="border border-primary p-3 text-center" onClick={handleClick}>
                { props.children }
            </div>

            <input
                type="file"
                accept={props.accept ? props.accept : '*'}
                ref={hiddenFileInput}
                onChange={handleChange}
                style={{display: 'none'}}
            />
        </React.Fragment>
    )

};
export default UploadButton;
